import React, { useState, useEffect } from 'react';
import Nabvar from '../components/Navbar/Navbar'
import MainPage from '../pages/MainPage/MainPage'
import Footer from '../components/Footer/Footer'

export default function IndexLayout({ logo }) {




    return (
        <div className='section-bg-color'>
            <Nabvar logo={logo} />
            <div className='espaciobg'>

            </div>
            <MainPage />
            <Footer logo={logo} />

        </div>
    );
}
